// import {
// 	getGroupsPerType,
// 	getGroupsPremiumHigher,
// 	getGroupsSalesEnterprise
// } from '../utils';
const menuConfig = {
	steel: [
		{
			path: '/steel/home',
			title: 'Steel Dashboard',
			icon: 'fa-dashboard',
			groups: []
		},
		// {
		// 	path: '/steel/smelterInfo',
		// 	title: 'Smelter Process',
		// 	icon: 'fa-flask',
		// 	groups: getGroupsPerType('steel')
		// },
		{
			path: '/steel/index',
			title: 'Smelter Operations',
			icon: 'fa-fire'
			// groups: getGroupsPerType('steel')
		},
		{
			path: '/steel/smeltersMap',
			title: 'Smelter Map',
			icon: 'fa-map-o'
			// groups: getGroupsSalesEnterprise('steel')
		},
		{
			path: '/steel/capacity',
			title: 'Smelter Capacity',
			icon: 'fa-line-chart'
		},
		{
			path: '/steel/production',
			subpaths: [
				{ name: 'Sites', hasChildren: false },
				{ name: 'Subsites', hasChildren: true }
			],
			title: 'Smelter Production',
			icon: 'fa-bar-chart'
		},
		{
			path: '/steel/co2Emissions',
			title: 'CO2 Emissions',
			icon: 'fa-industry',
			userRoles: ['superUser', 'admin']
			// groups: getGroupsPerType('steel')
		}
	],
	cu: [
		{
			path: '/cu/home',
			title: 'Copper Dashboard',
			icon: 'fa-dashboard'
		},
		{
			path: '/cu/index',
			title: 'Smelter Operations',
			icon: 'fa-line-chart'
		},
		{
			path: '/cu/smeltersMap',
			title: 'Smelter Map',
			icon: 'fa-map-o'
		},
		{
			path: '/cu/capacity',
			title: 'Smelter Capacity',
			icon: 'fa-line-chart'
		},
		{
			path: '/cu/production',
			title: 'Smelter Production',
			icon: 'fa-bar-chart'
		}
	],
	ni: [
		{
			path: '/ni/home',
			title: 'Nickel Dashboard',
			icon: 'fa-dashboard'
		},
		{
			path: '/ni/index',
			title: 'Smelter Operations',
			icon: 'fa-line-chart'
		},
		{
			path: '/ni/smeltersMap',
			title: 'Smelter Map',
			icon: 'fa-map-o'
		},
		{
			path: '/ni/capacity',
			title: 'Smelter Capacity',
			icon: 'fa-line-chart'
		},
		{
			path: '/ni/production',
			title: 'Smelter Production',
			icon: 'fa-bar-chart'
		}
	],
	al: [
		{
			path: '/al/home',
			title: 'Aluminium Dashboard',
			icon: 'fa-dashboard'
		},
		{
			path: '/al/index',
			title: 'Smelter Operations',
			icon: 'fa-line-chart'
		},
		{
			path: '/al/smeltersMap',
			title: 'Smelter Map',
			icon: 'fa-map-o'
		},
		{
			path: '/al/capacity',
			title: 'Smelter Capacity',
			icon: 'fa-line-chart'
		}
		// {
		// 	path: '/al/production',
		// 	title: 'Smelter Production',
		// 	icon: 'fa-bar-chart'
		// }
	],
	ironOre: [
		{
			path: '/ironOre/index',
			title: 'Iron Ore Data',
			icon: 'fa-line-chart'
		}
	],
	scrapSteel: [
		{
			path: '/scrapSteel/index',
			title: 'Scrap Steel Data',
			icon: 'fa-line-chart'
		}
	]
};

// const menuConfig = [
// 	{
// 		type: 'smelters',
// 		path: '/steel/smelters',
// 		title: 'Steel Indices',
// 		icon: 'fa-line-chart'
// 		// groups: getGroupsPerType('steel')
// 	},

// 	{
// 		type: 'smelters',
// 		path: '/steel/smeltersMap',
// 		title: 'Smelter Map',
// 		icon: 'fa-map-o'
// 		// groups: getGroupsSalesEnterprise('steel')
// 	},

// 	{
// 		type: 'stockpiles',
// 		path: '/ironOre/indices',
// 		title: 'Iron Ore Data',
// 		icon: 'fa-line-chart'
// 		// groups: getGroupsPerType('steel')
// 	}
// ];

export default menuConfig;
